export default __webpack_public_path__ + "static/media/logo-md-1920w.484bba94.webp";